import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@chakra-ui/react';
import Store from 'lib/Store/withLocalStorage';
import { useController } from 'pages/Meetings/hooks/useController';
import theme from 'styles/themes/default';

import config from 'config/general';

import { Wrapper } from 'components/atom/Grid';
import Loader from 'components/atom/Loader';
import Text from 'components/atom/Text/styles';

import { Title } from '../../styles';
import CardInvitation from './components/CardInvitation';
import {
  UseControllerInvitationsProvider,
  useControllerInvitations,
} from './hooks/useControllerInvitations';
import { ButtonType, Container, ContainerTypes } from './styles';
import { TypeInvitation } from './types';

const authStore = Store(`${config.localStorageKey}-auth`);

const Invitations: React.FC = () => {
  const [type, setType] = useState<TypeInvitation>('received');

  const { isLoading, invitationsReceived, invitationsSent } = useControllerInvitations();
  const { setPageActive, setInvitationData, setTypeInvitation, setProspectionId } = useController();

  const { t } = useTranslation();
  const isApp = authStore.getItem('isApp') === 'true';
  return (
    <Container>
      <Wrapper>
        {!isApp && <Title>{t('meetings:navigation.invitations')}</Title>}

        {isLoading ? (
          <Loader />
        ) : (
          <Box>
            <ContainerTypes>
              <ButtonType active={type === 'received'} onClick={() => setType('received')}>
                {t('meetings:actions.received')} ({invitationsReceived.length})
              </ButtonType>

              <ButtonType active={type === 'sent'} onClick={() => setType('sent')}>
                {t('meetings:actions.sent')} ({invitationsSent.length})
              </ButtonType>
            </ContainerTypes>

            <Box mt="6">
              {type === 'received' &&
                (invitationsReceived.length > 0 ? (
                  invitationsReceived.map((invitation) => (
                    <CardInvitation
                      key={invitation.matchId}
                      type={type}
                      {...invitation}
                      setInvitation={(type) => {
                        setPageActive('details');
                        setInvitationData(invitation);
                        setTypeInvitation(type);
                        setProspectionId(String(invitation.professionalId));
                      }}
                    />
                  ))
                ) : (
                  <Text weight="bold" padding="0 0 1rem" color={theme.colors.texts_light}>
                    {t('meetings:invitations.emptyReceived')}
                  </Text>
                ))}

              {type === 'sent' &&
                (invitationsSent.length > 0 ? (
                  invitationsSent.map((invitation) => (
                    <CardInvitation
                      key={invitation.matchId}
                      type={type}
                      {...invitation}
                      setInvitation={(type) => {
                        setPageActive('details');
                        setInvitationData(invitation);
                        setTypeInvitation(type);
                        setProspectionId(String(invitation.professionalId));
                      }}
                    />
                  ))
                ) : (
                  <Text weight="bold" padding="0]1rem 0 0" color={theme.colors.texts_light}>
                    {t('meetings:invitations.emptySent')}
                  </Text>
                ))}
            </Box>
          </Box>
        )}
      </Wrapper>
    </Container>
  );
};

const InvitationsWrapper: React.FC = () => (
  <UseControllerInvitationsProvider>
    <Invitations />
  </UseControllerInvitationsProvider>
);

export default InvitationsWrapper;
